export const SET_TABS = 'betTabs/SET_TABS'
export const SET_DATA = 'betTabs/SET_DATA'
export const SAVE_STATE = 'betTabs/SAVE_STATE'